import english from './translations/english';
import french from './translations/french';
import arabic from './translations/arabic';
import german from './translations/german';

export default { english, french, arabic, german };
